import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, timeout, retry } from "rxjs/operators";
import { Observable } from "rxjs";
import {  AppConfig } from "../../../app/app-config.module";

import { IMenu, Menu, MenuSearch } from "../../shared/models/menu.model";
import { IPagination, IResponse } from "../../shared/models/response.model";

@Injectable({
  providedIn: "root",
})
export class MenuService {
  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {}

  getMenuAll(): Observable<IResponse<IMenu[]>> {
    return this.http
      .post<IResponse<IMenu[]>>(`${this.config.apiEndpoint}/users/getmenu`, {})
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  getMenuManageList(
    pageNum: number,
    pageSize: number,
    menu: MenuSearch
  ): Observable<IResponse<IPagination<IMenu>>> {
    return this.http
      .post<IResponse<IPagination<IMenu>>>(`${this.config.apiEndpoint}/users/getlistmenumanage`, {
        pageNum: pageNum,
        pageSize: pageSize,
        ...menu,
      })
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  getMenuList(
    pageNum: number,
    pageSize: number,
    menu: MenuSearch
  ): Observable<IResponse<IMenu[]>> {
    return this.http
      .post<IResponse<IMenu[]>>(`${this.config.apiEndpoint}/users/getlistmenu`, {
        pageNum: pageNum,
        pageSize: pageSize,
        ...menu,
      })
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  getMenuById(menuId: string): Observable<IResponse<Menu>> {
    return this.http
      .post<IResponse<Menu>>(`${this.config.apiEndpoint}/users/getmenubyid`, { id: menuId })
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  createMenu(menu: Menu): Observable<IResponse<IMenu>> {
    return this.http
      .post<IResponse<IMenu>>(`${this.config.apiEndpoint}/users/createmenu`, menu)
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  updateMenu(menu: Menu): Observable<IResponse<IMenu>> {
    return this.http
      .post<IResponse<IMenu>>(`${this.config.apiEndpoint}/users/updatemenu`, menu)
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  deleteMenu(menuId: string): Observable<IResponse<string>> {
    return this.http
      .post<IResponse<string>>(`${this.config.apiEndpoint}/users/deletemenu`, { id: menuId })
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }

  getMainMenu(): Observable<IResponse<IMenu[]>> {
    return this.http
      .post<IResponse<IMenu[]>>(`${this.config.apiEndpoint}/users/getmainmenu`, {})
      .pipe(timeout(this.config.apiTimeout), retry(this.config.apiRetry));
  }
}
